import React, { FC } from 'react';
import { Text } from '@morressier/ts';
import { FaCreativeCommonsPd } from 'react-icons/fa';
import Grid from 'styled-components-grid';
import styled from 'styled-components';
import * as Styles from './styles';

const CardContent = styled.div`
  padding: 1rem;
  border: 1px solid rgb(217, 219, 223);
  border-radius: 3px;
`;

const IconContainer = styled.div`
  background-color: rgb(217, 219, 223);
  width: 8.5rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
  border-radius: 1px;
`;

enum License {
  LICENSE_TYPE_NO_LICENSE = 0,
  LICENSE_TYPE_CC_BY_40 = 1,
  LICENSE_TYPE_CC_BY_ND_40 = 2,
  LICENSE_TYPE_CC_BY_NC_40 = 3,
  LICENSE_TYPE_CC_BY_NC_ND_40 = 4,
}

const LicenseSection: FC<{ license?: License }> = props => {
  const { license } = props;
  if (license === undefined) return null;

  const licenses = {
    [License.LICENSE_TYPE_CC_BY_40]: {
      title: 'Attribution 4.0 International (CC BY 4.0)',
      imgName: 'by',
      link: 'https://creativecommons.org/licenses/by/4.0/',
    },
    [License.LICENSE_TYPE_CC_BY_ND_40]: {
      title: 'Attribution-NoDerivatives 4.0 International (CC BY-ND 4.0)',
      imgName: 'by-nd',
      link: 'https://creativecommons.org/licenses/by-nd/4.0/',
    },
    [License.LICENSE_TYPE_CC_BY_NC_40]: {
      title: 'Attribution-NonCommercial 4.0 International (CC BY-NC 4.0)',
      imgName: 'by-nc',
      link: 'https://creativecommons.org/licenses/by-nc/4.0/',
    },
    [License.LICENSE_TYPE_CC_BY_NC_ND_40]: {
      title: 'Attribution-NonCommercial-NoDerivs CC BY-NC-ND',
      imgName: 'by-nc-nd',
      link: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
    },
  };

  return license === License.LICENSE_TYPE_NO_LICENSE ? (
    <Styles.ZeroStateBox style={{ padding: '1rem' }}>
      <IconContainer>
        <FaCreativeCommonsPd size="3rem" color="rgb(142, 148, 158)" style={{ padding: '0.5rem' }} />
      </IconContainer>
      <Text style={{ marginBottom: '2rem' }} color="grey">
        No license information is available for this submission.
      </Text>
    </Styles.ZeroStateBox>
  ) : (
    <Grid>
      <Grid.Unit size={{ xlarge: 8 / 12 }}>
        <Styles.Card href={licenses[license].link} target="_blank" rel="noopener noreferrer">
          <CardContent>
            <figure>
              <img
                src={`https://next.morressier.com/discovery/static/containers/${licenses[license].imgName}.svg`}
                alt="License"
                style={{ marginBottom: '0.5rem' }}
              />
              <Text as="figcaption" style={{ marginBottom: '1rem' }}>
                {licenses[license].title}
              </Text>
            </figure>
          </CardContent>
        </Styles.Card>
      </Grid.Unit>
    </Grid>
  );
};

export default LicenseSection;
